module.exports = __webpack_public_path__ + "img/dd.5afd2cb1.png";